module.exports = __webpack_public_path__ + "static/media/8 (1).80618a49.webp";